/** What the one demonstration call is doing at a given beat. */
export type CallBeat = 'none' | 'calling' | 'failed' | 'handoff' | 'answered' | 'settled';

export interface Beat {
  /** how many rows have been revealed, top down */
  shown: number;
  call: CallBeat;
  /** how long this beat holds before the next one, in ms; the last beat holds forever */
  ms: number;
}

/* Design timings, chosen to be judged by eye: rows land close enough together
   that the rail reads as one line being drawn, and each step of the call holds
   long enough to read its caption once. */
const ARM_MS = 250;
const ROW_MS = 140;
const BEFORE_CALL_MS = 450;
const CALL_MS: Record<Exclude<CallBeat, 'none' | 'settled'>, number> = {
  calling: 800,
  failed: 1000,
  handoff: 550,
  answered: 1500,
};

/** The whole play, from every row hidden to the settled table. */
export const playScript = (rows: number): Beat[] => [
  ...Array.from({ length: rows + 1 }, (_, shown): Beat => ({
    shown,
    call: 'none',
    ms: shown === 0 ? ARM_MS : shown === rows ? BEFORE_CALL_MS : ROW_MS,
  })),
  ...(['calling', 'failed', 'handoff', 'answered'] as const).map(
    (call): Beat => ({ shown: rows, call, ms: CALL_MS[call] }),
  ),
  { shown: rows, call: 'settled', ms: 0 },
];
